import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export function ExploreReviewListSkeleton() {
  return (
    <div className="mt-2">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="skeleton-wave-item mb-4 bg-white rounded-lg"
          style={{
            animationDelay: `${(index + 1) * 0.15}s`,
          }}
        >
          <div className="p-4">
            <div className="flex justify-between items-start mb-3">
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-2">
                  <Skeleton width={100} height={20} />
                  <Skeleton width={80} height={16} />
                </div>
                <Skeleton width={120} height={14} />
              </div>
            </div>
            <div className="mb-3">
              <Skeleton
                width="100%"
                height={400}
                className="rounded-lg aspect-[3/4]"
              />
            </div>
            <div className="flex flex-col gap-2">
              <Skeleton count={3} />
              <Skeleton width={60} height={16} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
